module.exports = __webpack_public_path__ + "static/media/mhssz-logo-small.562de503.png";